<template>
  <div class="module">
    <div class="module__title"></div>
    <div class="module__content">
      <image-swiper :swiperList="swiperList"></image-swiper>
      <news-list :news="news"></news-list>
    </div>
  </div>
</template>
  
<script>
import ImageSwiper from './components/ImageSwiper.vue'
import NewsList from './components/NewsList.vue'

import newsMixins from '@/mixins/newsMixins.js'

export default {
  name: 'MobileHomeNews',
  mixins: [newsMixins],
  components: {
    ImageSwiper,
    NewsList,
  }
}
</script>

<style lang="scss" scoped>
.module {
  height: 209.333333vw;

  &__title {
    background-position: center 0;
  }

  &__content {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 2.533333vw;
    padding: 2.8vw 2.333333vw 0;
    width: 94.8vw;
    height: 148.533333vw;
    background: url('~@/assets/img/mobile/news_bg.png') no-repeat;
    background-size: 100%;
  }
}
</style>